import {
  Avatar,
  Button,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import HandshakeIcon from "@mui/icons-material/Handshake";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { PageHeader } from "../../../components/PageHeader";
import { useEffect, useState } from "react";
import {
  getGoogleSearchQueryDetail,
  setupDomainRelation,
} from "../../../api/specialization/SocialSpecializationAPI";
import { OptionsObject, useSnackbar } from "notistack";
import { AlertSuccessProp } from "../../../components/SnackbarNoti";
import { labels } from "../../specialization/author/AuthorStatsConverter";
import RandomColor from "../../../util/RandomColor";
import { Pie } from "react-chartjs-2";
import { Chart, Chart as ChartJS, registerables } from "chart.js";
import GoogleTrends from "../../../components/embed/GoogleTrends";
ChartJS.register(...registerables);
export function GoogleQueryDetailPage() {
  const { t } = useTranslation(["common", "social", "keyword"]);
  const { id } = useParams();
  const [pageData, setPageData] = useState(null);
  const [reloadCondition, setReloadCondition] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (parseInt(id) > 0) {
      getGoogleSearchQueryDetail(parseInt(id)).then((res) => {
        setPageData(res);
        console.log(pageData);
      });
    }
  }, [reloadCondition]);

  var listSearchResults = [];
  var opponentCounts = 0;
  var partnerCounts = 0;
  var ownerCounts = 0;

  if (pageData && pageData["recentResults"]) {
    listSearchResults = pageData["recentResults"].map((res) => {
      var backgroundColor = "hsl(1, 0%, 99%)";
      if (res["domain"]) {
        console.log(res["domain"]);
        for (var i = 0; i < pageData["domains"].length; i++) {
          console.log(pageData["domains"]);
          if (res["domain"] == pageData["domains"][i].domain) {
            if (pageData["domains"][i].relationType == "OPPONENT") {
              opponentCounts++;
              backgroundColor = "hsl(6, 100%, 93%)";
            }
            if (pageData["domains"][i].relationType == "PARTNER") {
              partnerCounts++;
              backgroundColor = "hsl(131, 100%, 93%)";
            }
            if (pageData["domains"][i].relationType == "OWNER") {
              ownerCounts++;
              backgroundColor = "hsl(201, 100%, 93%)";
            }
          }
        }
      }
      return (
        <Link
          href={res["url"]}
          underline="none"
          target={"_blank"}
          rel="noopener noreferrer"
        >
          <ListItem
            className="grey-hover"
            style={{
              paddingTop: "0px",
              paddingBottom: "0px",
              minWidth: "500px",
              backgroundColor: backgroundColor,
            }}
          >
            <ListItemAvatar style={{ marginTop: "4px" }}>
              <Avatar
                alt={res["url"]}
                src={
                  "https://www.google.com/s2/favicons?domain=" +
                  new URL(res["url"]).hostname +
                  "/favicon.ico"
                }
              ></Avatar>
            </ListItemAvatar>
            <Tooltip title={res.description}>
              <ListItemText
                style={{ maxWidth: "100%", width: "100%" }}
                primary={res.title}
                primaryTypographyProps={{ fontSize: "15px", color: "#1a0dab" }}
                secondary={new URL(res["url"]).hostname}
                secondaryTypographyProps={{ fontSize: "13px" }}
              ></ListItemText>
            </Tooltip>
            <Tooltip title={t("social:label_this_domain_as_yours")}>
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  setupDomainRelation(
                    new URL(res["url"]).hostname,
                    "OWNER"
                  ).then((res) => {
                    enqueueSnackbar(
                      t("common:update_successfully"),
                      AlertSuccessProp as OptionsObject
                    );
                    setReloadCondition(!reloadCondition);
                  });
                }}
                color="info"
              >
                <CopyrightIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("social:label_this_domain_as_partner")}>
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  setupDomainRelation(
                    new URL(res["url"]).hostname,
                    "PARTNER"
                  ).then((res) => {
                    enqueueSnackbar(
                      t("common:update_successfully"),
                      AlertSuccessProp as OptionsObject
                    );
                    setReloadCondition(!reloadCondition);
                  });
                }}
                color="success"
              >
                <HandshakeIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("social:label_this_domain_as_opponent")}>
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  setupDomainRelation(
                    new URL(res["url"]).hostname,
                    "OPPONENT"
                  ).then((res) => {
                    enqueueSnackbar(
                      t("common:update_successfully"),
                      AlertSuccessProp as OptionsObject
                    );
                    setReloadCondition(!reloadCondition);
                  });
                }}
                color="error"
              >
                <LocalFireDepartmentIcon />
              </IconButton>
            </Tooltip>
          </ListItem>
        </Link>
      );
    });
  }

  const pieLabels = [
    t("social:OWNED"),
    t("social:PARTNER"),
    t("social:OPPONENT"),
    t("social:UNKNOWN"),
  ];

  const pieData = {
    labels: pieLabels,
    datasets: [
      {
        label: "NOTHING",
        data: [
          ownerCounts,
          partnerCounts,
          opponentCounts,
          10 - ownerCounts - partnerCounts - opponentCounts,
        ],
        backgroundColor: ["OWNED", "PARTNER", "OPPONENT", "UNKNOWN"].map(
          (label) => {
            return RandomColor({ name: label });
          }
        ),
      },
    ],
  };

  const todayPieData = {
    labels: pieLabels,
    datasets: [
      {
        label: "NOTHING",
        data: [
          pageData ? pageData["proportion"]["owners"] : 0,
          pageData ? pageData["proportion"]["partners"] : 0,
          pageData ? pageData["proportion"]["opponents"] : 0,
          pageData
            ? pageData["proportion"]["total"] -
              pageData["proportion"]["owners"] -
              pageData["proportion"]["partners"] -
              pageData["proportion"]["opponents"]
            : 0,
        ],
        backgroundColor: ["OWNED", "PARTNER", "OPPONENT", "UNKNOWN"].map(
          (label) => {
            return RandomColor({ name: label });
          }
        ),
      },
    ],
  };
  const pieOptions = {
    plugins: {
      legend: { position: "bottom" as const, display: true },
      title: {
        display: false,
        text:
          t("social:content_sources_about") +
          (pageData ? pageData.query.query : ""),
      },
    },
    responsive: true,
  };
  return (
    <Grid container spacing={0}>
      <PageHeader text={pageData ? pageData.query.query : ""}></PageHeader>
      <Grid container xs={12}>
        <Grid item xs={0.75}></Grid>
        <Grid item xs={5}>
          <Typography
            variant="h5"
            align="left"
            marginTop={"10px"}
            fontWeight={600}
          >
            {t("social:recent_search_results")}
          </Typography>
          <List className="white">{listSearchResults}</List>
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={5}>
          <Typography
            variant="h5"
            align="left"
            marginTop={"10px"}
            fontWeight={600}
          >
            {t("social:overall_statistics")}
          </Typography>
          <Grid
            container
            xs={12}
            className="white"
            alignContent={""}
            alignItems={"horizontal"}
          >
            <div
              style={{ marginLeft: "auto", marginRight: "auto", width: "40%" }}
            >
              <Typography
                variant="h6"
                align="center"
                marginTop={"10px"}
                fontWeight={500}
              >
                {t("social:recent_content_source")}
              </Typography>
              <Pie options={pieOptions} data={pieData}></Pie>
            </div>
            <div
              style={{ marginLeft: "auto", marginRight: "auto", width: "40%" }}
            >
              <Typography
                variant="h6"
                align="center"
                marginTop={"10px"}
                fontWeight={500}
              >
                {t("social:content_source") + " " + t("social:last_24h")}
              </Typography>
              <Pie options={pieOptions} data={todayPieData}></Pie>
            </div>
          </Grid>
          <Grid container xs={12} className="white">
            <div
              style={{ marginLeft: "auto", marginRight: "auto", width: "40%" }}
            >
              <Typography
                variant="h6"
                align="center"
                marginTop={"10px"}
                fontWeight={500}
              >
                {t("social:dominant_domains")}
              </Typography>
            </div>
            <div
              style={{ marginLeft: "auto", marginRight: "auto", width: "40%" }}
            >
              <Typography
                variant="h6"
                align="center"
                marginTop={"10px"}
                fontWeight={500}
              >
                {t("social:dominant_urls")}
              </Typography>
            </div>
            <div id="google-trends-embed"></div>
            {pageData ? (
              <GoogleTrends
                elementId={"google-trends-embed"}
                type={"GEO_MAP"}
                comparison={[]}
                keyword={pageData ? pageData.query.query : ""}
                geo={"VN"}
                time={"today 12-m"}
                property={""}
              />
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Grid item xs={0.75}></Grid>
      </Grid>
    </Grid>
  );
}
